import { styled } from "../../../styled-components";

export const SummaryViewStyle = styled.div`
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    .summary-title {
        color: ${p => p.theme.fgColorDark};
        ${p => p.theme.summary.title.fontStyle};
    }

    .summary-subtitle {
        color: ${p => p.theme.fgColorMedium};
        ${p => p.theme.summary.detail.fontStyle};
    }
`;
